import { useEffect } from 'react';
import { useAppStore } from '../store/useAppStore';
import { ProRequestForm } from '../components/ProRequestForm';
import { logAnalytics } from '../utils/database';

export const ProPage = () => {
  const { session, isAuthenticated, isLoading, error, setError } = useAppStore();

  useEffect(() => {
    // This page requires authentication, so ensure session is valid
    if (!isLoading && !isAuthenticated && !error) {
      // If not authenticated and not loading, it means session validation failed or is missing
      setError('Authentication required to access this page. Please log in.');
    }

    // Log page access
    logAnalytics('pro_page_access', {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userId: session?.hy_user_id || 'unauthenticated'
    });

  }, [isAuthenticated, isLoading, error, session?.hy_user_id, setError]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <img
            src="https://qsiwkqsdtbfftmxbnhie.supabase.co/storage/v1/object/public/public/c599a7b3-23d3-4f3a-a44b-b1801b7cdf24.gif"
            alt="Loading..."
            className="w-[500px] h-[500px] mx-auto rounded-lg"
          />
        </div>
      </div>
    );
  }

  // This page is now deprecated in favor of dynamic pro pages
  // It will be removed in a future update.
  // For now, it will just show a message.
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        <h1 className="text-2xl font-bold text-th-primary">Pro Page Deprecated</h1>
        <p className="text-th-secondary">This page is no longer in use. Please use dynamic pro forms instead.</p>
        <button onClick={() => window.history.back()} className="button-primary">Go Back</button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen">
      <header className="border-b border-subtle bg-surface sticky top-0 z-30">
        <div className="px-4 py-4">
          <div className="flex items-center justify-between max-w-6xl mx-auto">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-brand rounded-lg flex items-center justify-center">
                <span className="text-white text-sm">✨</span>
              </div>
              <div>
                <h1 className="text-lg font-bold text-th-primary">Pro Request Studio</h1>
                <p className="text-xs text-th-secondary">Submit custom AI requests</p>
              </div>
            </div>
            <button
              onClick={() => window.history.back()}
              className="flex items-center space-x-2 px-3 py-2 text-th-secondary hover:text-th-primary transition-colors rounded-lg hover:bg-overlay"
            >
              <span>Back</span>
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-8">
        <ProRequestForm />
      </main>
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-brand/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/5 rounded-full blur-3xl" />
      </div>
    </div>
  );
};